let selectedCases = document.querySelector('.selected-cases');
if (selectedCases != null) {
    selectedCases
        .addEventListener('wheel', (e) => {
                let wrapper = document.querySelector('.section-cases');
                wrapper.scrollLeft -= e.wheelDelta;

                let canScrollLeft = e.wheelDelta > 0 && wrapper.scrollLeft > 0;
                let canScrollRight = e.wheelDelta < 0 && wrapper.offsetWidth + wrapper.scrollLeft < wrapper.scrollWidth;

                /* If the user is scrolling up or down in the wrapper and is not at either of the edges of the scroll bar,
                 lock vertical scroll and scroll horizontally */
                if (canScrollLeft || canScrollRight) {
                    e.preventDefault();
                }
            }
        );
}